import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useAuthStore = defineStore(
    'auth',
    () => {
        const token = ref('');
        const refreshKey = ref('');

        const setToken = (newToken: string, newRefreshToken: string) => {
            token.value = newToken;
            refreshKey.value = newRefreshToken || refreshKey.value;
        };
        const clearToken = () => {
            token.value = '';
            refreshKey.value = '';
        };
        return {
            token,
            refreshKey,
            setToken,
            clearToken,
        };
    },
    {
        persist: true,
    }
);
